import {
  SDKCodeResponse,
  SDKInstructionSection,
  SDKContentSection,
} from "../services/MfaSDKCodeService";

export const formatSDKInstructionsV2 = (
  response: SDKCodeResponse,
  language: string,
): string => {
  try {
    const { instructions } = response;

    if (!instructions) return "";
    let markdown = "";
    if (instructions.title) {
      markdown += `# ${instructions.title}\n\n`;
    }

    instructions.sections.forEach((section: SDKInstructionSection) => {
      if (section.content) {
        section.content.forEach((item: SDKContentSection) => {
          if (item.text) markdown += item.text;
          if (item.code) markdown += ` \`${item.code}\` `;
          if (item.link) markdown += `[${item.link.text}](${item.link.url})`;
        });
        markdown += "\n\n";
      }

      if (section.list) {
        section.list.forEach((listItem) => {
          if (listItem.content) {
            listItem.content.forEach((item: SDKContentSection) => {
              if (item.text) markdown += item.text;
              if (item.code) markdown += ` \`${item.code}\` `;
              if (item.link)
                markdown += `[${item.link.text}](${item.link.url})`;
            });
            markdown += "\n\n";

            if (listItem.codeBlock) {
              if (listItem.codeBlock.filename) {
                markdown += `#### ${listItem.codeBlock.filename}\n\n`;
              }
              markdown += `\`\`\`${language}\n`;
              markdown += `${listItem.codeBlock.code}\n`;
              markdown += "```\n\n";
            }
          }
        });
      }
    });

    return markdown.trim();
  } catch (error) {
    console.error("Error formatting SDK instructions:", error);
    return "";
  }
};
